var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-view',{attrs:{"entity_name":"contactTicket","title":"Contact Tickets","headers":_vm.headers}})
}
var staticRenderFns = []

export { render, staticRenderFns }